<nav mat-tab-nav-bar>
    <button mat-tab-link *ngFor="let graphLink of graphLinks"
            [routerLink]="graphLink.url"
            routerLinkActive="mdc-tab--active"
            [active]="isRouteActive(graphLink.url)"
            appAriaTitle>
        {{graphLink.label | translate}}
    </button>
</nav>